import { ReactNode, VFC } from 'react'
import {
  black,
  bordergray,
  mediumGray,
  orange,
  truewhite,
  _profilehrborder,
  errorRed,
  _message_submenu,
  safetyOrange,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { flexCenter } from 'src/styles/mixins'
import styled, { css } from 'styled-components'

export type FormItemProps = {
  id: string
  label: string
  note?: string
  icon?: string
  optional?: boolean
}
type FormItemWrapperProps = FormItemProps & {
  children: ReactNode
}
export const FormItemWrapper: VFC<FormItemWrapperProps> = ({
  id,
  label,
  note,
  icon,
  optional,
  children,
}) => {
  return (
    <>
      <FormItemDiv>
        {icon && <Icon src={icon} alt="icon" />}
        <FormLabel htmlFor={id}>
          {label}
          {!optional && <RequiredMark>必須</RequiredMark>}
          {note && <FormNote>{note}</FormNote>}
        </FormLabel>
      </FormItemDiv>
      <div>{children}</div>
    </>
  )
}

export const Title: VFC<{ title: string; description: string }> = ({
  title,
  description,
}) => {
  return (
    <>
      <TitleDiv>
        <FormTitle>{title}</FormTitle>
        <FormDescription>{description}</FormDescription>
      </TitleDiv>
    </>
  )
}

const Icon = styled.img`
  margin-right: 5px;
  width: 20px;
`

export const formInputStyle = css`
  height: 52px;
  padding: 6px 12px;
  color: #6f6f6f;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
  transition: all ease-in-out 0.15s;

  :focus {
    border-color: #66afe9;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
  }
`

export const invalidStyle = css`
  border-color: ${errorRed};
  box-shadow: none;

  :focus {
    border-color: ${errorRed};
    box-shadow: unset;
  }
`

export const formWidthStyle = css`
  margin: 19px auto 10px;
  max-width: 700px;
`

const TitleDiv = styled.div`
  ${formWidthStyle};
`

const FormItemDiv = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 26px;
  margin-bottom: 10px;
  label {
    flex: 1;
    cursor: pointer;
  }
  div {
    margin-top: 10px;
    width: 100%;
    @media screen and (min-width: 1024px) {
      margin-top: 0;
      width: 66%;
    }
  }
`

const FormLabel = styled.label`
  font-size: 14px;
  font-weight: ${fontWeightBold};
  text-align: left;
  color: ${_message_submenu};
`
const FormNote = styled.p`
  font-size: 14px;
`

const RequiredMark = styled.span`
  margin-left: 8px;
  padding: 3px 10px;
  border-radius: 12px;

  font-size: 13px;
  font-weight: ${fontWeightBold};
  color: ${truewhite};
  background: ${errorRed};
`

export const FormTitle = styled.h1`
  max-width: 700px;
  padding-left: 10px;

  font-size: 24px;
  font-weight: ${fontWeightBold};
`
export const FormDescription = styled.p`
  margin-top: 10px;
  max-width: 700px;
  padding-left: 10px;

  color: ${_message_submenu};
  font-size: 12px;
  line-height: 1.1rem;
  white-space: pre-wrap;
`

export const FormSpacer = styled.hr<{
  marginTop?: number
  marginBottom?: number
}>`
  margin-top: ${({ marginTop }) => (marginTop ? `${marginTop}px` : '19px')};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? `${marginBottom}px` : '19px'};
  border: 0;
  border-top: 1px solid ${_profilehrborder};
`

export const Control = styled.div`
  display: flex;
  font-size: 14px;
  font-weight: ${fontWeightBold};
  color: ${mediumGray};
  padding-bottom: 12px;

  button {
    display: block;
    padding: 0 12px;
    border-left: 1px solid ${bordergray};
    :first-child {
      padding: 0 12px 0 0;
      border-left: none;
    }
  }
`

export const DeselectButton = styled.button`
  color: ${orange};
`

export const SelectableItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
  width: 100%;
`
export const SelectableItemDiv = styled.div`
  label {
    color: ${black};
    font-size: 14px;
    line-height: 20px;
    font-weight: ${fontWeightBold};
    border: 1px solid ${bordergray};
    background: ${truewhite};
    padding: 4px 16px;
    border-radius: 28px;
    min-width: 60px;
    ${flexCenter};
    margin: 6px;
    cursor: pointer;
  }
  input {
    display: none;
  }
  input:checked + label {
    background: ${orange};
    border-color: ${orange};
    color: ${truewhite};
  }
`

export const labelHoverEffectStyle = css`
  width: 100%;
  position: relative;
  border-radius: 5px;

  // NOTE: ぼかし
  :hover::before {
    display: block;
    width: 100%;
    height: 100%;

    position: absolute;
    top: 0;
    left: 0;

    content: '';
    border-radius: 5px;
    color: ${safetyOrange};
    background-color: rgba(255, 108, 1, 0.05);
    backdrop-filter: blur(3px);
  }

  // NOTE: ぼかしの上の文字
  :hover::after {
    display: block;
    min-width: 160px;
    height: 40px;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);

    text-align: center;
    align-items: center;
    content: var(--blur-text, '編集する');
    font-weight: ${fontWeightBold};
    color: ${safetyOrange};
    border: solid 1px ${safetyOrange};
    border-radius: 5px;
    background-color: rgb(255, 255, 255);
    padding: 10px 16px;
  }
`
